<template>
  <div class="main fc ac">
    <img style="width: 100%;" src="../../assets/volunteer/头部.png" alt />

    <van-tabs class color="#FB5363" type="card">
      <van-tab title="志愿者服务">
        <div class="p20" style="font-size:14px;letter-spacing: 2px;">
          <div class="sj">根据《中国红十字志愿服务管理办法》的规定：</div>
          <div
            class="sj "
          >凡参与由团体单位组织或参加的红十字志愿服务活动的个人，即成为红十字志愿者。团体单位应填写《中国红十字志愿服务活动统计表》，对相关情况进行统计登记，并在所在地红十字会备案，为志愿者配发中国红十字志愿服务卡和服饰。</div>
          <div
            class="sj "
          >个人申请加入红十字志愿者，应填写《中国红十字志愿者登记表》，对相关情况进行登记，并在所在地红十字会备案，经报县及县以上红十字志愿服务工作委员会批准后，配发红十字志愿者证、中国红十字志愿服务卡和服饰，即成为红十字志愿者。志愿服务时间每年累计达到20 小时的红十字志愿者，应主动到所在地红十字会进行申请，成为注册红十字志愿者。</div>
        </div> 
      </van-tab>
      <van-tab title="在线报名登记表">
        <!-- 提交表单 -->
        <div v-if="!apply_sucess" style="padding-left:30px;padding-right:30px">
          <div class="mt20" style="font-weight: bold;">真实姓名</div>

          <input
            v-model="submit_form.name"
            class="mt10"
            type="text"
            placeholder="请输入您的真实姓名"
            style="width: 100%;height: 25px;padding: 4px;border-radius: 2px;"
          />

          <div class="mt10" style="font-weight: bold;">手机号</div>

          <input
            v-model="submit_form.mobile"
            class="mt10"
            type="text"
            placeholder="请输入您的手机号码"
            style="width: 100%;height: 25px;padding: 4px;border-radius: 2px"
          />

          <div class="mt10" style="font-weight: bold;">所属街道/镇</div>

          <div>
            <div
              @click="address_show=true"
              class="mt10 fr jc ac"
              style="border-color:white;border-radius: 3px; padding: 4px;   border: 1px solid #dcdfe6;background-color: #fff;"
            >{{submit_form.address}}</div>
          </div>

          <van-button class="mt20" type="danger" block @click="submit">提交</van-button>
        </div>
        <!-- 提交成功 -->
        <div class="fc jc ac" v-if="apply_sucess">
          <img
            style="width:105px;height:105px;margin-top: 130px;"
            src="../../assets/index/笑脸.png"
            alt
          />

          <div class="fr jc ac mt30" style="color: #FB5363;font-weight: bold;">您的信息已登记成功!</div>

          <div class="fr jc ac" style="color: #FB5363;font-weight: bold;">我们将于十个工作日联系你</div>
        </div>
      </van-tab>
    </van-tabs>

    <img class="bottom" style="width: 100%;height:98px" src="../../assets/volunteer/底部.png" alt />

    <van-popup v-model="address_show" position="bottom">
      <van-picker
        show-toolbar
        :columns="address_list"
        @cancel="address_show = false"
        @confirm="confirmAddress"
      ></van-picker>
    </van-popup>
  </div>
</template>

<script>

import { Toast } from 'vant';
export default {
  name: "home",

  data() {
    return {
      submit_form: {
        contribute_type: 3,
        contribute_name: "志愿者服务",
        name: "",
        mobile: "",
        address: "请选择"
      },
      apply_sucess: false,
      address_show: false,
      address_list: [
        "请选择",
        "吴淞街道",
        "友谊路街道",
        "罗店镇",
        "大场镇",
        "杨行镇",
        "月浦镇",
        "罗泾镇",
        "顾村镇",
        "高境镇",
        "庙行镇",
        "淞南镇",
        "宝山工业区",
        "城市工业园区"
      ]
    };
  },

  methods: {
    //提交
    submit() {
      if (!this.submit_form.name) {
        Toast("请输入名字");
        return;
      }

      if (this.submit_form.mobile.length!=11) {
        Toast("请输入正确的手机号");
        return;
      }

      if (this.submit_form.mobile == "请选择") {
        Toast("请选择地址");
        return;
      }
      this.apply_sucess = true;
      this.post("contribute/add", this.submit_form).then(res => {});
    },
    toZxgxb() {
      this.$router.push({
        path: "zxgxb"
      });
    },
    toJxxz() {
      this.$router.push({
        path: "jxxz"
      });
    },
    toCjd() {
      this.$router.push({
        path: "cjd"
      });
    },
    toJxlc() {
      this.$router.push({
        path: "jxlc"
      });
    },
    //确认地址
    confirmAddress(item) {
      this.submit_form.address = item;
      this.address_show = false;
    },
    toSignUp() {
      window.open("http://np-culture.org/event/sh-blood/redcross/");
    }
  },
  components: {},
  mounted() {}
};
</script>


<style lang="less" scoped>
.main {
  box-sizing: border-box;
  // padding: 44px;
  width: 100vw;
  height: 100vh;

  //   background-image: url("./../../assets/index/bg.png");
  background-size: contain;
  background-color: #fffafa;
}
.active {
  background-color: #fb5358;
  color: white;
}
.black {
  color: black;
}
/deep/ .van-collapse-item__content {
  color: black;
}

/deep/ .van-collapse-item__content {
  color: black;
}
/deep/ .van-collapse-item__content {
  background-color: #fffafa;
}
.red {
  font-weight: bold;
  color: #fb5363;
}
/deep/.van-cell__title {
  font-weight: bold;
}

/deep/ .van-tabs {
  width: 100%;
}
/deep/.van-tabs__nav--card {
  margin: 0;
}
.bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 98px;
}
</style>